import { z } from 'zod'

export const leadgenForm = z.object({
    id: z.string(),
    name: z.string(),
    status: z.string(),
    locale: z.string(),
})
